// src/components/ProductsTable.js
import React, { useEffect, useState } from "react";
import { getProducts } from "../api";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // ✅ import the function directly

function ProductsTable() {
  const [products, setProducts] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState("");

  useEffect(() => {
    getProducts().then(setProducts);
  }, []);

  // Apply filter
  const filteredProducts = products.filter(p =>
    categoryFilter ? p.category === categoryFilter : true
  );

  // ✅ Export to Excel
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredProducts);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");
    XLSX.writeFile(workbook, "Products.xlsx");
  };

  // ✅ Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Products Report", 14, 10);

    autoTable(doc, {
      head: [["Name", "Category", "Unit"]],
      body: filteredProducts.map(p => [p.name, p.category, p.unit]),
      startY: 20,
    });

    doc.save("Products.pdf");
  };

  return (
    <div style={{ marginTop: "24px" }}>
      <h2>Products</h2>

      {/* Category Filter */}
      <label>
        Filter by Category:{" "}
        <select
          value={categoryFilter}
          onChange={e => setCategoryFilter(e.target.value)}
        >
          <option value="">All Categories</option>
          <option value="CCE">CCE</option>
        </select>
      </label>

      {/* Table */}
      <table border="1" width="100%" style={{ marginTop: "10px", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Unit</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map(p => (
            <tr key={p._id}>
              <td>{p.name}</td>
              <td>{p.category}</td>
              <td>{p.unit}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Export buttons */}
      <div style={{ marginTop: "10px" }}>
        <button onClick={exportToExcel}>Export to Excel</button>
        <button onClick={exportToPDF} style={{ marginLeft: "10px" }}>
          Export to PDF
        </button>
      </div>
    </div>
  );
}

export default ProductsTable;
